import {Component, Inject, OnInit, Renderer2,ElementRef, PLATFORM_ID} from '@angular/core';
import {Filters, Product, Wheels} from '../../shared/interfaces/wheels';
import {ApiServices} from '../../shared/services/api.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {DataService} from '../../shared/services/data.service';
import {HelperService} from '../../shared/services/helper.service';
import {ToastrService} from 'ngx-toastr';
import {MetaService} from '../../shared/services/meta.service';
import {FormService} from '../../shared/services/form.service';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {FormGroup, Validators} from '@angular/forms';

import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-brand',
  templateUrl: './brand.component.html',
  styleUrls: ['./brand.component.scss']
})
export class BrandComponent implements OnInit {


  queryParams: Params;
  allBrands:any = [];
  loadMoreBrands = false;
  loadBrands = false;
  brand:any = '';
  product:any = '';

  hasNextPage = false;
  
  closeResult: string;
  totalPrice: number;
  isLoading = false;
  diameter: number;

  brandProducts:any = [];
  brandProductVariants:any = [];
  wheelSizeTypes = [];
  moreSizes = [];
  

  constructor(
    private apiService: ApiServices,
    private dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private helperService: HelperService,
    private metaService: MetaService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private _renderer2: Renderer2, 
    private elRef: ElementRef,
    private formService: FormService,
  ) {

    // this.route.snapshot.paraMap.get('brand');

    // this.currentRoute = 'wheelsbrand';


    helperService.setPageTitle(route.snapshot.data.title);


    this.route.params.subscribe(param => {
      this.brand = param.brand
      this.product = param.product
    });

  }

  ngOnInit(): void {
    this.checkIfLoggedIn();
    this.resolveMetaTags();

    if(this.product){
      this.getProductVariants();
    }
    else if(this.brand){
      this.getBrandProducts();
    }
    else {
      this.getAllBrands();
    }
    
  }

  checkIfLoggedIn() {
    const token = localStorage.getItem('ts_vendor_access_token');
    if(token) {
    } else {
      this.toastr.error("Please login first", 'Error');
      this.router.navigateByUrl('/');
      // this.router.navigate(['/']);
    }
  }

  resolveMetaTags(): void {
    let metaData: any = {
      title: this.route.snapshot.data.breadcrumbs.title,
      description: this.route.snapshot.data.breadcrumbs.description,
    };

    if(this.brand){
      const search = /__BRAND__/gi;
      metaData.title = metaData.title.replace(search, this.brand);
      this.helperService.setPageTitle(metaData.title);
      metaData.description = metaData.description.replace(search, this.brand);
    } else {
      const search = /__BRAND__/gi;
      metaData.title = metaData.title.replace(search, 'Brands');
      this.helperService.setPageTitle(metaData.title);
      metaData.description = metaData.description.replace(search, this.brand);
    }
    // if (this.currentRoute == '/wheelbrand') {
    //   const search = /__BRAND__/gi;
    //   metaData.title = metaData.title.replace(search, this.brand);
    //   this.helperService.setPageTitle(metaData.title);
    //   metaData.description = metaData.description.replace(search, this.brand);
    // }
    
    this.helperService.setCustomMeta(metaData);
      this.metaService.updateCanonicalURL();

    // if(this.currentRoute == "/wheelbrand" && this.brand != undefined ){
    //   this.metaService.updateCanonicalURLParam('brand='+this.brand);
    // } else {
    //   this.metaService.updateCanonicalURL();
    // }
  }

  getAllBrands = () => {
    this.loadBrands = true;
    const queryParams = Object.assign({}, this.queryParams);
    this.apiService.getAllBrands(queryParams).subscribe(
      (response: any) => {
        this.allBrands = [...this.allBrands, ...response.data.brands.data];
        this.loadMoreBrands = false;
        this.loadBrands = false;
        
        if (response.data.brands.next_page_url) {
          this.hasNextPage = true;
        } else {
          this.hasNextPage = false;
        }
      }, err => {
        this.loadMoreBrands = false;
      }
    );
  }

  loadMore = () => {
    this.loadMoreBrands = true;
    setTimeout( () => {
      const params = Object.assign({}, this.queryParams);
      params.page = params.page ? ++params.page : 2;
      this.router.navigate(['wheelbrand'], {queryParams: params});
    }, 500);
  }


  getBrandProducts = () => {
    // this.loadBrands = true;
    this.wheelSizeTypes = [];
    const queryParams = Object.assign({}, this.queryParams);
    this.apiService.getAllBrandProducts(queryParams, this.brand).subscribe(
      (response: any) => {
        // this.brandProducts = [...this.brandProducts, ...response.data.products];
        this.brandProducts = response.data.products;

        

        // this.loadMoreBrands = false;
        // this.loadBrands = false;
        
        // if (response.data.brands.next_page_url) {
        //   this.hasNextPage = true;
        // } else {
        //   this.hasNextPage = false;
        // }
      }, err => {
        // this.loadMoreBrands = false;
      }
    );
  }


  getProductVariants = () => {
    // this.loadBrands = true;
    this.wheelSizeTypes = [];
    const queryParams = Object.assign({}, this.queryParams);
    this.apiService.getAllBrandProductVariants(queryParams, this.brand, this.product).subscribe(
      (response: any) => {
        // this.brandProducts = [...this.brandProducts, ...response.data.products];
        this.brandProductVariants = response.data.products;
        this.wheelSizeTypes = response.data.more_sizes;


        if( this.wheelSizeTypes.length > 0 ){
          this.getVariantsData(this.brandProductVariants.product.id, this.wheelSizeTypes[0]);
        }

        // this.loadMoreBrands = false;
        // this.loadBrands = false;
        
        // if (response.data.brands.next_page_url) {
        //   this.hasNextPage = true;
        // } else {
        //   this.hasNextPage = false;
        // }
      }, err => {
        // this.loadMoreBrands = false;
      }
    );
  }

  getVariantsData = (pId, diameter) => {
    // console.log(pId, vId, diameter);
    this.apiService.getProductMoreSizes(pId, diameter).subscribe(
      response => {
        // console.log(response);
        if(response.data.sizes.length > 0){
          this.moreSizes = response.data.sizes;
        }
        
      }, error => {
        this.helperService.showErrors(error);
      }
    );

  }



  


  


}
